import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import orderBy from 'lodash/orderBy';
import {getServicesList, setService} from '../../actions/outgoingService';
import {getOutgoingCalls, getIncomingCalls} from '../../actions/getCalls';
import {changeServiceName, getCallUrl} from '../../actions/call';
import {getAgentInfo} from '../../actions/getAgentConfig';
import Loader from '../Components/Loader';
import classnames from 'classnames';
import { logData } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
class AssignToAnotherService extends Component {

  constructor(props) {
    super(props);
    this.state = {
			isShow: false,
			showModal:props.showModal,
      showErr: false,
      errorHeight: 0,
      searchFilter: '',
      services: []
		};
  }
  close = (key) => {
    this.props.handleClose(key);
  }
  // gets service list
  getServiceList = () => {
    this.setState({
      call_id: this.props.CallId,
      loading: this.state.services.length == 0,
      showErr: false,
      searchFilter: '',
      service: ''
    });
    if(this.state.services.length == 0){
      this.props.getServicesList().then((res) => {
        this.setState({
          services: res.payload,
          loading: false,
        });
      }, (err) => {
        this.setState({
          loading: false,
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        });
        logData(err);
      });
    }
  }
  // updates state with selected service
  changeService = (type) => {
    this.setState({service: type});
  }
  // updates state with search filter value
  handleSearchServiceChange = (e) => {
    this.setState({
      searchFilter: e.target.value
    });
  }
  getErrorHeight = () => {
    const errorHeight = document.getElementById('alertWrapper').clientHeight;
    this.setState({
      errorHeight: errorHeight + 21
    });
  }
  // renders list with services
  renderList = () => {
    return orderBy(this.state.services, [data => data.name ? data.name.toLowerCase() : ''], ['asc'])
      .filter(service => service.name && service.name.toLowerCase()
      .includes(this.state.searchFilter.toLowerCase()))
      .map(item => {
        return (
        <button
          key={item.id}
          type="button"
          onClick={() => this.changeService(item.id)}
          className={classnames(`list-group-item list-group-item${this.props.theme}` , {active: this.state.service==item.id})}>
          {item.name}
        </button>
      )
    });
  }

  updateTabData = (call_id, data, name) => {
    this.props.getCallUrl(call_id, this.state.service, data.data.to, data.data.from, data.data.autodialer_id).then((res) => {
      if(res.data.result){
        const url = res.data.response.items[0].data.url.length > 0 ? res.data.response.items[0].data.url : null;
        const open_popup = res.data.response.items[0].data.open_popup;
        const newData = {
          id: call_id,
          service_id: res.data.response.items[0].data.service_id ? res.data.response.items[0].data.service_id : this.state.service,
          service_name: name,
          url,
          open_popup,
          mandatory_end_of_business: res.data.response.items[0].data.mandatory_end_of_business
        };
        this.props.changeServiceName(newData);
      }
    }, () => {
      // toast.error('Error while getting url', {autoClose: false});
    })
  }
  // closes alert
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  // updates selected service
  handleSubmit = () => {
    if(!this.state.service){
      this.setState({
        showErr: true,
        errorMsg: this.props.translations.assignToAnotherServiceError[this.props.selectedLanguage]
      }, () => {
        this.getErrorHeight();
      });
      return;
    }else{
      const payload = {
        service_id: this.state.service,
        call_id: this.state.call_id,
      }
      this.props.setService(payload).then((res) => {
        if(res.data.result){
          if(this.props.getCalls!==null){
            const { name } = this.state.services.find(item => item.id == this.state.service);
            // prop to refresh calls
            setTimeout(() => {
              this.props.getCalls('service_name', name, 'service_id', this.state.service);
            }, 2000);
            const tabData = this.props.callEvents.find(item => item.data.id == this.state.call_id);
            if(tabData){
              this.updateTabData(this.state.call_id, tabData, name);
            }
          }
          this.props.handleClose(this.props.showModal);
        }else{
          this.setState({
            showErr: true,
            errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
          }, () => {
            this.getErrorHeight();
          });
        }
      }, (err) => {
        logData(err);
        this.setState({
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage]
        }, () => {
          this.getErrorHeight();
        });
      });
    }
  }

  render(){
    const {
      loading,
      showErr,
      errorHeight
    } = this.state;
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal
        onEnter={this.getServiceList}
        show={this.props.showModal}
        onHide={() => this.close('showModal')}
        backdrop="static"
        bsSize="sm">
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.assignToAnotherService[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {showErr && <div className="alertWrapper" id="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          {!loading && <div className="input-with-icon w-full">
          <input
            type="text"
            className={`form-control${this.props.theme} input-smm${this.props.theme}`}
            placeholder={translations.search[selectedLanguage]}
            style={ {marginBottom: '0.5rem'} }
            onChange={ this.handleSearchServiceChange }
          />
          <span className="icon icon-magnifying-glass" />
          </div>}
          <div className="list-group" style={{maxHeight: showErr ? `calc(345px - ${errorHeight}px)` : 345, overflow: 'auto'}}>
            {loading && <Loader width="20px" height="20px" />}
            {this.renderList()}
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button type="button" onClick={() => this.close('showModal')} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
          <button type="submit" onClick={this.handleSubmit} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentInfo: state.agentInfo,
        callEvents: state.callEvents.events,
        servicesList: state.servicesList,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}
function mapDispatchToProps (dispatch) {
    return bindActionCreators({
      getServicesList,
      setService,
      getAgentInfo,
      getOutgoingCalls,
      getIncomingCalls,
      changeServiceName,
      getCallUrl
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignToAnotherService);



// WEBPACK FOOTER //
// ./src/agent/modals/AssignToAnotherService.js